import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level7Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3986" data-mp="3g6ayahl0nk58">
      <div className="relative w-full h-full bg-gradient-to-b from-emerald-200 to-teal-400 overflow-hidden" data-id="element-3987" data-mp="hoxc0el0dy1w">
        {/* Background: Big tree */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3988" data-mp="7w9flkxxxw3p">
          <path d="M0 170 L200 170 L200 200 L0 200 Z" fill="#15803D" opacity="0.5" data-id="element-3989" data-mp="10e3xg9d6t3re" />
          {/* Trunk */}
          <rect x="150" y="90" width="10" height="80" rx="3" fill="#92400E" data-id="element-3990" data-mp="vksl5splvus3" />
          {/* Canopy */}
          <circle cx="155" cy="80" r="34" fill="#22C55E" data-id="element-3991" data-mp="njfi9slvvhcr" />
          <circle cx="135" cy="92" r="24" fill="#16A34A" data-id="element-3992" data-mp="rhv2xpuhsdn0" />
          <circle cx="176" cy="92" r="22" fill="#16A34A" data-id="element-3993" data-mp="drj8hkafq2sp" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-start pb-[8%] pl-[8%]" data-id="element-3994" data-mp="iqmg9chsun4d">
          <div className="w-[56%] h-[56%] flex items-center justify-center" data-id="element-3995" data-mp="io9oy8q5j0en">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3996" data-mp="3s0rncptmx4v" />
          </div>
        </div>

        {/* Foreground: level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3997" data-mp="1p7q2m3bw30g7">
            <circle cx="40" cy="40" r="18" fill="#0F766E" data-id="element-3998" data-mp="1rso0ziid6ilg" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="900" fill="white" data-id="element-3999" data-mp="1noztt0xn9p0q">
              7
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}